import { computed, onMounted, onBeforeUnmount, reactive, watch } from "vue";
import { useAuthStore } from "@/stores/AuthStore";

const preferences = reactive(new Map());
const normalize = (value) => (value === "classic" ? "classic" : "new");
const read = (key) => {
  try {
    return normalize(window.localStorage.getItem(key));
  } catch {
    return "new";
  }
};

// Appearance preferences are per account on this browser, like other local display settings.
export function useReferenceLayout() {
  const auth = useAuthStore();
  const key = computed(
    () => `neptune_reference_layout:${auth.user?.id ?? "guest"}`,
  );
  watch(
    key,
    (storageKey) => {
      if (!preferences.has(storageKey))
        preferences.set(storageKey, read(storageKey));
    },
    { immediate: true },
  );
  const referenceLayout = computed({
    get() {
      return preferences.get(key.value);
    },
    set(value) {
      const layout = normalize(value);
      preferences.set(key.value, layout);
      try {
        window.localStorage.setItem(key.value, layout);
      } catch {
        // Continue with the in-memory preference when browser storage is unavailable.
      }
    },
  });
  const sync = (event) => {
    if (event.key === key.value || event.key === null) {
      preferences.set(key.value, read(key.value));
    }
  };
  onMounted(() => window.addEventListener("storage", sync));
  onBeforeUnmount(() => window.removeEventListener("storage", sync));
  return {
    referenceLayout,
    isClassic: computed(() => referenceLayout.value === "classic"),
  };
}
